var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("codeEditor", {
    attrs: {
      value: _vm.code,
      lang: _vm.safeLanguage,
      theme: _vm.safeTheme,
      width: _vm.width,
      height: _vm.height,
      options: { readOnly: _vm.readonly, autoScrollEditorIntoView: true },
      id: "editor"
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      },
      init: function($event) {
        return _vm.editorInit($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a06d238e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a06d238e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/ace_editor.vue
// module id = null
// module chunks = 